import { render, staticRenderFns } from "./gs-basket-button.vue?vue&type=template&id=060c055a"
import script from "./gs-basket-button.vue?vue&type=script&lang=ts"
export * from "./gs-basket-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports